export default __webpack_public_path__ + "static/media/A_Arvore.00a12f0f.svg";